import { css } from '@emotion/css';

export const checkboxCx = css`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: start;

  .MuiCheckbox-root {
    padding: 0;

    .MuiSvgIcon-root {
      width: 1.25rem;
      height: 1.25rem;
    }

    &.Mui-checked {
      color: #00acf0;
    }
  }

  .checkbox-label {
    margin-left: 0.25rem;

    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;

    color: #404040;
  }
`;
